import { render, staticRenderFns } from "./error404.vue?vue&type=template&id=47d85d30&scoped=true&"
import script from "./error404.vue?vue&type=script&lang=js&"
export * from "./error404.vue?vue&type=script&lang=js&"
import style0 from "./error404.vue?vue&type=style&index=0&id=47d85d30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d85d30",
  null
  
)

export default component.exports